import o from "./SidebarElement.vue2.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const r = /* @__PURE__ */ t(o, [["__scopeId", "data-v-a006c277"]]);
export {
  r as default
};
